import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorPage from '../ErrorPage';
import FullPageProgress from '../FullPageProgress';
import RedirectToPreview from '../RedirectToPreview/RedirectToPreview';

const FeedbackPage = React.lazy(() => import('../../controllers/feedbackPage'));
const FeedbackRoom = React.lazy(() => import('../../controllers/feedbackRoom'));
const FeedbackUpdateFeed = React.lazy(() => import('../../controllers/FeedbackUpdateFeed/FeedbackUpdateFeed'));
const MeetLeave = React.lazy(() => import('../../controllers/Meet/MeetLeave'));
const MeetRoom = React.lazy(() => import('../../controllers/Meet/MeetRoom'));
const RecordingPage = React.lazy(() => import('../../controllers/recordingPage'));
const RecordingRoom = React.lazy(() => import('../../controllers/recordingRoom'));
const UpdateFeedbackRoom = React.lazy(() => import('../../controllers/UpdateFeedbackRoom/UpdateFeedbackRoom'));
const UrlGeneratedId = React.lazy(() => import('../Pages/UrlGeneratedId'));
const PostLeave = React.lazy(() => import('../PostLeave'));
const JoiningScreen = React.lazy(() => import('../zoomSdk/JoiningScreen'));
const PreviewScreen = React.lazy(() => import('../PreviewScreen'));
const Conference = React.lazy(() => import('../conference'));

const withSuspense = (element) => <Suspense fallback={<FullPageProgress />}>{element}</Suspense>;

const RouteList = ({ getDetails, authTokenByRoomCodeEndpoint }) => {
    return (
        <Routes>
            <Route path="meet">
                <Route
                    path="preview/:role/:roomId"
                    element={withSuspense(<MeetRoom endPoint={authTokenByRoomCodeEndpoint} roomType="preview" />)}
                />
                <Route path="meeting/:role/:roomId" element={withSuspense(<MeetRoom roomType="meeting" />)} />
                <Route path="recording/:roomId" element={withSuspense(<MeetRoom roomType="recording" />)} />
                <Route path="transcript/:roomId" element={withSuspense(<MeetRoom roomType="transcript" />)} />
                <Route path="leave/:role/:roomId" element={withSuspense(<MeetLeave />)} />
            </Route>
            <Route path="meet/:interviewId/:urlGenerateId" element={withSuspense(<UrlGeneratedId />)} />
            <Route path="interview">
                <Route path="room/:roomId" element={withSuspense(<JoiningScreen />)} />
            </Route>
            <Route path="recording">
                <Route path="room/:interviewId/:roomId/:role" element={withSuspense(<RecordingRoom />)} />
                <Route path="room/:interviewId/:roomId" element={withSuspense(<RecordingRoom />)} />
                <Route path=":roomId" element={withSuspense(<RecordingPage />)} />
            </Route>
            <Route path="feedback">
                <Route path="room/:interviewId/:roomId" element={withSuspense(<FeedbackRoom />)} />
                <Route path=":roomId" element={withSuspense(<FeedbackPage />)} />
            </Route>
            <Route path="feedback-update">
                <Route path="room/:interviewId/:interviewKey" element={withSuspense(<FeedbackUpdateFeed />)} />
                <Route
                    path="room/:interviewId/:interviewKey/:tenantId"
                    element={withSuspense(<FeedbackUpdateFeed />)}
                />
            </Route>
            <Route path="feedbackUpdate">
                <Route path="room/:interviewId/:roomId/:role" element={withSuspense(<UpdateFeedbackRoom />)} />
                <Route path="room/:interviewId/:roomId" element={withSuspense(<UpdateFeedbackRoom />)} />
            </Route>
            <Route path="preview">
                <Route
                    path=":role/:roomId"
                    element={withSuspense(<PreviewScreen authTokenByRoomCodeEndpoint={authTokenByRoomCodeEndpoint} />)}
                />
            </Route>
            <Route path="meeting">
                <Route path=":role/:roomId" element={withSuspense(<Conference />)} />
            </Route>
            <Route path="leave">
                <Route path=":role/:roomId" element={withSuspense(<PostLeave />)} />
            </Route>
            <Route path="/:role/:roomId" element={<RedirectToPreview getDetails={getDetails} />} />
            <Route path="*" element={<ErrorPage error="Invalid URL!" />} />
        </Routes>
    );
};

export default RouteList;
